import Img from './close.png';
import './Close.css';

const Close = () => {
    return (
        <img className='img-close' src={Img} alt="" />
    );
}

export default Close;
